import React, { useCallback, useMemo } from 'react';
import { message } from 'antd';

import { Link } from 'ui-kit';
import { coHostRemove, useCoHostList } from 'api/co-hosts';
import Wrapper from 'components/Wrapper';
import AddCoHostButtonModal from './AddCoHostButtonModal';
import CoHostsTable from './Table';
import _ from 'lodash';

export interface ICoHostWrapper {
  isDisabled: boolean;
}

const CoHostWrapper = ({ isDisabled }: ICoHostWrapper) => {
  const { data: coHosts, mutate: updateCoHosts, error } = useCoHostList();

  const handleRemoveCoHost = useCallback(
    ({ id }: { id: number }) =>
      coHostRemove({ id })
        .then(() => {
          updateCoHosts();
          message.success('Co-Host removed successfully.');
        })
        .catch((error) => message.error(error.message)),
    [updateCoHosts],
  );

  const hasError = useMemo(() => !_.isUndefined(error), [error]);

  return (
    <Wrapper className="hc-settings">
      {isDisabled || hasError ? (
        <p className="upgrade-txt">
          * <Link href={`/pricing/`}>Upgrade to Pro Plus</Link> to add Co-Hosts.
        </p>
      ) : (
        <>
          <AddCoHostButtonModal />
          <CoHostsTable coHosts={coHosts} onRemove={handleRemoveCoHost} />
        </>
      )}
    </Wrapper>
  );
};

export default CoHostWrapper;
